import React from 'react';
import StatusCards from './StatusCard';

const LeadManagementTab = ({
  isMobile,
  leadData,
  progressData,
  isReadOnly,
  onAssignOwner,
  onEditFollowUp,
  onUpdateStatus,
  onAddFollowUp,
  onChangeStage,
  onSetPriority,
  onSetInteractionLevel,
  handleStepClick,
  setProgressData
}) => {
  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      {/* Operational Status Cards */}
      <StatusCards
        isMobile={isMobile}
        leadData={leadData}
        isReadOnly={isReadOnly}
        onAssignOwner={onAssignOwner}
        onEditFollowUp={onEditFollowUp}
        onUpdateStatus={onUpdateStatus}
        onAddFollowUp={onAddFollowUp}
        onChangeStage={onChangeStage}
        onSetPriority={onSetPriority}
        onSetInteractionLevel={onSetInteractionLevel}
      />
    </div>
  );
};

export default LeadManagementTab;
